import React from 'react';
import { NavLink } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import {
  LayoutDashboard,
  Users,
  UserPlus,
  FilePlus,
  History,
  Settings,
  Menu,
  X,
  CreditCard,
  TrendingUp,
  Calendar
} from 'lucide-react';

const Sidebar = () => {
  const { state, dispatch } = useApp();
  const { sidebarCollapsed } = state;

  const menuItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', color: 'text-blue-400' },
    { path: '/customers', icon: Users, label: 'View Customers', color: 'text-green-400' },
    { path: '/add-customer', icon: UserPlus, label: 'Add Customer', color: 'text-purple-400' },
    { path: '/create-invoice', icon: FilePlus, label: 'Create Invoice', color: 'text-yellow-400' },
    { path: '/invoice-history', icon: History, label: 'Invoice History', color: 'text-orange-400' },
    { path: '/add-transaction', icon: CreditCard, label: 'Add Transaction', color: 'text-cyan-400' },
    { path: '/transactions', icon: TrendingUp, label: 'View Transactions', color: 'text-emerald-400' },
    { path: '/transaction-history', icon: Calendar, label: 'Transaction History', color: 'text-pink-400' },
    { path: '/settings', icon: Settings, label: 'Settings', color: 'text-gray-400' }
  ];

  const toggleSidebar = () => {
    dispatch({ type: 'TOGGLE_SIDEBAR' });
  };

  return (
    <div className={`fixed left-0 top-0 h-full bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white shadow-2xl transition-all duration-300 z-50 backdrop-blur-sm border-r border-slate-700 ${
      sidebarCollapsed ? 'w-14' : 'w-56'
    }`}>
      {/* Header */}
      <div className="p-3 border-b border-slate-700">
        <div className="flex items-center justify-between">
          {!sidebarCollapsed && (
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-lg">C</span>
              </div>
              <div>
                <h1 className="text-lg font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                  CMS Admin
                </h1>
                <p className="text-xs text-slate-400">Management System</p>
              </div>
            </div>
          )}
          <button
            onClick={toggleSidebar}
            className="p-1 rounded-lg hover:bg-slate-700 transition-all duration-200 hover:scale-105"
          >
            {sidebarCollapsed ? <Menu size={16} className="text-slate-300" /> : <X size={16} className="text-slate-300" />}
          </button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="mt-3 px-2">
        {menuItems.map((item, index) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center ${sidebarCollapsed ? 'justify-center px-1' : 'px-2'} py-2 mb-1 rounded-lg transition-all duration-200 group relative ${
                isActive 
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg transform scale-105' 
                  : 'text-slate-300 hover:bg-slate-700 hover:text-white hover:transform hover:scale-105'
              }`
            }
          >
            <item.icon size={16} className={`${sidebarCollapsed ? 'mx-auto' : 'mr-2'} transition-colors`} />
            {!sidebarCollapsed && (
              <span className="ml-2 font-medium text-sm">{item.label}</span>
            )}
            {!sidebarCollapsed && (
              <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-2 h-2 bg-current rounded-full"></div>
              </div>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      {!sidebarCollapsed && (
        <div className="absolute bottom-3 left-2 right-2">
          <div className="bg-slate-800 rounded-lg p-2 border border-slate-700">
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-bold">A</span>
              </div>
              <div>
                <p className="text-xs font-medium text-white">Admin User</p>
                <p className="text-xs text-slate-400">Administrator</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
